import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, ReactiveFormsModule } from '@angular/forms';
import { SheetActionControlsBase } from 'src/app/services/sheets-renderer.service';
import { Row, Slot } from 'src/app/types/aggregate-graph.types';
import { UrineAction } from 'src/app/types/sheet-action-aggregate-graph.types';
import { ActionFormComponent } from '../../action-form/action-form.component';
import { CommonActionControlsComponent } from '../../common-action-controls/common-action-controls.component';
import { CheckboxControl } from 'src/app/form-controls/checkbox/checkbox.control';

interface UrineActionFormGroup {
	urinePassed: FormControl<boolean | null>;
}

@Component({
    selector: 'app-urine-action-controls',
    templateUrl: './urine-action-controls.component.html',
    styleUrls: ['../../../common.scss', './urine-action-controls.component.scss'],
    imports: [ReactiveFormsModule, CommonActionControlsComponent, ActionFormComponent, CheckboxControl],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class UrineActionControlsComponent implements SheetActionControlsBase {

	slot!: Slot | null;
	action!: UrineAction;

	@Input('slot') set updateSlot(slot: Slot | null) {
		this.slot = slot;
		this.action = slot?.action as UrineAction;
	}

	@Input() item!: Row | null;
	@Input() form!: FormGroup<UrineActionFormGroup>;

	constructor(private formBuilder: FormBuilder) {
	}

	ngOnInit() {
		this.form.addControl('urinePassed', this.formBuilder.control(this.action?.urinePassed ?? null));
	}
}